export default "__VITE_ASSET__DIi5D$Qt__"